<template>
    <div>
        <br/>

        <form class="form-horizontal" v-if="! ibutton">
            <div class="form-group">
                <div class=" col-sm-3">
                    <button @click="solicitar()" type="button" class="btn btn-block btn-xs btn-warning">
                        <i class="fa fa-save"></i> SOLICITAR IBUTTONS</button>
                </div>

                <div class=" col-sm-3">
                    <button @click="load()" type="button" class="btn btn-block btn-xs btn-info">
                        <i class="fa fa-refresh"></i> RECARREGAR IBUTTONS</button>
                </div>

            </div>
        </form>

        <div v-if=" ibuttons.length">
            Total: <b>{{ibuttons.length}} Ibuttons</b>
            <table class="table table-bordered table-striped" >
                <thead style="background-color: #1c699d; color: white;">
                <tr>
                    <td class="text-center" style="width: 80px; padding: 10px">NUM</td>
                    <td class="text-left" style=" padding: 10px">SERIAL <input type="text" v-model="serial_search" class="form-control" id="imei" placeholder="Serial"></td>
                    <td class="text-center" style="width: 100px; padding: 10px" v-if="id_cliente"></td>
                </tr>
                </thead>
                <tbody >
                <tr v-for="i in ibuttonsFilter">
                    <td style="vertical-align: center" class="text-center">{{ i.position }}</td>
                    <td style="vertical-align: center">{{ i.serial }}</td>
                    <td class="text-center" v-if="id_cliente">
                        <button type="button" @click="add(i.serial)" class="btn btn-xs btn-info">
                            CADASTRA NO CLIENTE
                        </button>
                    </td>
                </tr>
                </tbody >
            </table>
        </div>

        <div v-else>
            <h3>Nenhum IButton Adicionado</h3>
        </div>
    </div>
</template>

<script>
import {Rastreador, RST} from '../../../../class';
import {Bus} from '../../../../class/bus';

    export default {
        name: "ListagemIbuttons",
        props: {
            id_rastreador: {
                default: null
            },
            id_cliente: {
                default: null
            }
        },
        data () {
            return {
                serial_search: null,
                ibuttons: [],
                ibutton: null
            }
        },
        beforeMount() {
            this.load();
        },
        computed: {
            // a computed getter
            ibuttonsFilter:  function () {
                if (! this.serial_search) {
                    return this.ibuttons;
                }
                // `this` points to the vm instance
                return this.ibuttons.filter((e) => {
                    return String(e.serial).includes(this.serial_search);
                })
            }
        },
        methods: {
            solicitar () {
                RST.solicitarIbuttons(this.id_rastreador);
                Bus.$emit('comandos');
            },
            load () {
                Rastreador.ibuttons(this.id_rastreador).then((data) => {
                    this.ibuttons = data;
                });
            },
            
        }
    }
</script>

<style scoped>

</style>
